import without from 'lodash/without';

export default class MessageBrokerQueue {
  active = [];

  pending = [];

  constructor(limit) {
    this.limit = limit;
  }

  /**
   * @param {MessageBrokerRequest} request
   */
  push(request) {
    if (!request) return;
    this.pending.push(request);
  }

  /**
   * @param {MessageBrokerRequest} request
   */
  release(request) {
    if (this.active.indexOf(request) !== -1) {
      this.active = without(this.active, request);
    } else {
      this.pending = without(this.pending, request);
    }
    request.destroy();
  }

  next() {
    if (this.active.length < this.limit && this.pending.length) {
      const next = this.pending.shift();
      this.active.push(next);

      return next;
    }

    return undefined;
  }

  each(iterator) {
    this.active.forEach(iterator);
    this.pending.forEach(iterator);
  }
}
